// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 715 ? "vendors-5a94f17d" : chunkId) + "." + {"235":"66aa47e0","715":"e3134802"}[chunkId] + ".chunk.css";
};